import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ActionComponent } from "./modules/provider/action/action.component";
import { ApplicationsComponent } from "./modules/provider/applications/applications.component";
import { ProviderLayoutComponent } from "./modules/provider/layout/provider-layout.component";
import { ProviderDashComponent } from "./modules/provider/provider-dash/provider-dash.component";
import { AccountComponent } from "./modules/user/account/account.component";
import { AllocationComponent } from "./modules/user/allocation/allocation.component";
import { BiddingComponent } from "./modules/user/bidding/bidding.component";
import { FixedRateBidComponent } from "./modules/user/fixed-rate-bid/fixed-rate-bid.component";
import { HistoryComponent } from "./modules/user/history/history.component";
import { LayoutComponent } from "./modules/user/layout/layout.component";
import { LoginComponent } from "./modules/user/login/login.component";
import { MarketComponent } from "./modules/user/market/market.component";
import { PendingApprovalComponent } from "./modules/user/pending-approval/pending-approval.component";
import { RegisterComponent } from "./modules/user/register/register.component";
import { ReportComponent } from "./modules/user/report/report.component";
import { StrikePriceComponent } from "./modules/user/strike-price/strike-price.component";
import { WalletComponent } from "./modules/user/wallet/wallet.component";
import { WelcomeScreenComponent } from "./modules/user/welcome-screen/welcome-screen.component";
import { UtilityWelcomeScreenComponent } from "./modules/user/utility-welcome-screen/utility-welcome-screen.component";
import { AdminComponent } from "./modules/admin/test/admin/admin.component";
import { DashboardComponent } from "./modules/utility/dashboard/dashboard.component";
import { AuthGaurd } from "./shared/gaurds/auth.guard";
import { LoggedInGaurd } from "./shared/gaurds/loggedin.guard";
import { PendingGuard } from "./shared/gaurds/pending.guard";
import { RegisterGuard } from "./shared/gaurds/register.guard";
import { ServiceProviderGuard } from "./shared/gaurds/serviceProvider.guard";
import { SuperAdminGuard } from "./shared/gaurds/super-admin.guard";
import { UserGuard } from "./shared/gaurds/user.guard";
import { UtilityGaurd } from "./shared/gaurds/utility.guard";
import { IntegrationPartnerGuard } from "./shared/gaurds/integration-partner.guard";
import { UserWalletComponent } from "./modules/user/user-wallet/user-wallet.component";
import { WebPaymentModelComponent } from "./modules/user/web-payment-model/web-payment-model.component";
import { SmartMeterDataComponent } from "./modules/utility/smart-meter-data/smart-meter-data.component";
import { UtilityDashboardComponent } from "./modules/utility/utility-dashboard/utility-dashboard.component";
import { HomepageComponent } from "./modules/utility/homepage/homepage.component";
import { BidHistoryComponent } from "./modules/utility/bid-history/bid-history.component";
import { SettlementComponent } from "./modules/utility/settlement/settlement.component";
// import { TestComponent } from "./modules/user/test/test.component";

const routes: Routes = [
  { path: "", redirectTo: "homepage", pathMatch: "full" },
  {
    path: "welcome",
    canActivate: [LoggedInGaurd],
    component: WelcomeScreenComponent,
  },
  {
    path: "utility-welcome",
    canActivate: [LoggedInGaurd],
    component: UtilityWelcomeScreenComponent,
  },
  {
    path: "login",
    canActivate: [LoggedInGaurd],
    component: LoginComponent,
    data: { isLogin: true },
  },
  {
    path: "utility-login",
    canActivate: [LoggedInGaurd],
    component: LoginComponent,
    data: { isLogin: true, role: 'Utility' },
  },
  {
    path: "register",
    canActivate: [RegisterGuard],
    component: RegisterComponent,
    data: { isLogin: false },
  },
  {
    path: "pending-registration-mobile",
    canActivateChild: [PendingGuard],
    component: PendingApprovalComponent,
  },
  {
    path: "",
    canActivateChild: [PendingGuard],
    component: LayoutComponent,
    children: [{ path: "pending", component: PendingApprovalComponent }],
  },
  {
    path: "",
    component: LayoutComponent,
    canActivate: [AuthGaurd, UserGuard],
    children: [
      { path: "market", component: MarketComponent },
      {
        path: "buy",
        component: BiddingComponent,
        data: { transactionType: "buy", offer: "requirement" },
      },
      {
        path: "sell",
        component: BiddingComponent,
        data: { transactionType: "sell", offer: "supply" },
      },
      { path: "strike", component: StrikePriceComponent },
      { path: "strike/:id", component: StrikePriceComponent },
      { path: "allocation", component: AllocationComponent },
      { path: "allocation/:id", component: AllocationComponent },
      { path: "history", component: HistoryComponent },
      { path: "fixed-rate-bid/:id", component: FixedRateBidComponent },
      { path: "account", component: AccountComponent },
      {
        path: "wallet",
        component: WalletComponent,
        data: { hideHeader: true },
      },

      {
        path: "payments",
        loadChildren: () =>
          import(
            "./modules/user/payment-transactions/payment-transactions.module"
          ).then((m) => m.PaymentTransactionsModule),
      },
      { path: "user-wallet", component: UserWalletComponent },
      { path: "payment", component: WebPaymentModelComponent },
      //  {path:"payment1",component:TestComponent}
    ],
  },
  {
    path: "",
    canActivate: [AuthGaurd, UtilityGaurd],
    children: [
      { path: "admin", component: AdminComponent },
      { path: "homepage", component: HomepageComponent }, // New Dashboard P2P design
      { path: "dashboard", component: HomepageComponent }, 
      { path: "utility-dashboard", component: UtilityDashboardComponent, data:{bid_type:'daily'} },
      { path: "preferential", component: UtilityDashboardComponent, data:{bid_type:'preferential'} },
      { path: "smart-meter-data", component: SmartMeterDataComponent },
      { path: "bid-history", component: BidHistoryComponent },
      { path: "settlement", component: SettlementComponent },
      { path: "report", component: ReportComponent },
    ],
  },
  {
    path: "",
    canActivate: [AuthGaurd, IntegrationPartnerGuard],
    children: [
      { path: "partner-dashboard", component: HomepageComponent },
      { path: "partner-dynamic", component: UtilityDashboardComponent, data: { bid_type: 'daily' } },
      { path: "partner-preferential", component: UtilityDashboardComponent, data: { bid_type: 'preferential' } },
      { path: "partner-smart-meter-data", component: SmartMeterDataComponent },
      { path: "partner-bid-history", component: BidHistoryComponent },
      { path: "partner-settlement", component: SettlementComponent },
    ],
  },
  {
    path: "",
    component: ProviderLayoutComponent,
    canActivate: [AuthGaurd, ServiceProviderGuard],
    children: [
      {
        path: "provider-dash",
        component: ProviderDashComponent,
        data: { title: "Dashboard" },
      },
      {
        path: "applications/:applicationStateId",
        component: ApplicationsComponent,
        data: { title: "Application list, status" },
      },
      {
        path: "action/:applicationId",
        component: ActionComponent,
        data: { title: "Application list, status" },
      },
    ],
  },
  {
    path: "admin-dash",
    canActivate: [SuperAdminGuard],
    loadChildren: () =>
      import("./modules/admin/admin-dash.module").then(
        (m) => m.AdminDashModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
